import { render, staticRenderFns } from "./sharing.vue?vue&type=template&id=fd5443c6&"
import script from "./sharing.vue?vue&type=script&lang=js&"
export * from "./sharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports